import { createContext, useState, useEffect, Context, ReactNode } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { darkTheme, lightTheme } from "@/styles/mui-theme";
import { getTheme, setTheme, checkAndSetTheme } from "./storage";

export type Theme = "light" | "dark";

const defaultTheme = checkAndSetTheme();

const ThemeContext: Context<{ theme: Theme; toggleTheme: () => void }> = createContext({
  theme: defaultTheme,
  toggleTheme: () => {},
});

const ThemeProvider: ({ children }: { children: ReactNode }) => JSX.Element = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [currentTheme, setCurrentTheme] = useState("light" as Theme);
  const muiTheme = currentTheme === "light" ? lightTheme : darkTheme;

  const toggleTheme = () => {
    const value: Theme = currentTheme === "light" ? "dark" : "light";

    setCurrentTheme(value);
    setTheme(value);
    document.documentElement.setAttribute("data-theme", value);
  };

  useEffect(() => {
    const value = (getTheme() || "light") as Theme;
    setCurrentTheme(value);
  }, []);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeContext.Provider value={{ theme: currentTheme, toggleTheme }}>{children}</ThemeContext.Provider>
    </MuiThemeProvider>
  );
};

export { ThemeContext, ThemeProvider };
